export const hasExportRoute = url => url.includes("/export");
